import React from 'react';
import { Download } from 'lucide-react';
import { useApp } from '../../context/AppContext';
import { exportTakeoffToExcel } from '../../services/excel';

export const ActionBar: React.FC = () => {
  const {
    lineItems,
    equipmentItems,
    pvWireItems,
    pagePathsMap,
    drawnWireTotals,
    selectedFileName,
  } = useApp();

  const hasData =
    lineItems.length > 0 ||
    equipmentItems.length > 0 ||
    pvWireItems.length > 0 ||
    Object.keys(pagePathsMap).length > 0;

  if (!hasData) {
    return null;
  }

  const handleExport = () => {
    exportTakeoffToExcel({
      pdfFileName: selectedFileName,
      lineItems,
      equipmentItems,
      pvWireItems,
      pagePathsMap,
      drawnWireFeetText: `${drawnWireTotals.total.toFixed(1)} ft`,
      drawnWirePositiveText: `${drawnWireTotals.positive.toFixed(1)} ft`,
      drawnWireNegativeText: `${drawnWireTotals.negative.toFixed(1)} ft`,
      drawnWireOtherText: `${drawnWireTotals.other.toFixed(1)} ft`,
      hasOtherWire: drawnWireTotals.other > 0,
    });
  };

  return (
    <div className="action-bar">
      <button type="button" className="export-button" onClick={handleExport}>
        <Download className="h-5 w-5" />
        <span>Download Excel</span>
      </button>
    </div>
  );
};
